import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach access token from localStorage (fallback for cross-site cookies)
// Also attach X-Consortium-Id so multi-tenant backend routes are scoped correctly.
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sally_access_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const cid = localStorage.getItem("sally_active_consortium_id");
  if (cid) cfg.headers["X-Consortium-Id"] = cid;
  return cfg;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
